import { useState } from 'react';
import type { Faq } from '@/mocks/faqs';

interface FaqAccordionProps {
  items: Faq[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openId, setOpenId] = useState<string | null>(items[0]?.id ?? null);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item) => {
        const open = openId === item.id;
        return (
          <div key={item.id}>
            <button
              type="button"
              aria-expanded={open}
              onClick={() => setOpenId(open ? null : item.id)}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 md:px-6 md:py-5"
            >
              <span className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-accent-100 text-xs font-bold text-accent-800">
                  Q
                </span>
                <span className="font-heading text-sm font-semibold text-foreground-900 md:text-base">
                  {item.question}
                </span>
              </span>
              <i
                className={`shrink-0 text-xl text-foreground-400 transition-transform duration-200 ${
                  open ? 'rotate-180' : ''
                } ri-arrow-down-s-line`}
              ></i>
            </button>
            {open && (
              <div className="px-5 pb-5 md:px-6 md:pb-6">
                <div className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xs font-bold text-primary-700">
                    A
                  </span>
                  <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}